export default __webpack_public_path__ + "static/media/SSK.dde02af5.png";